import { Controller } from '../utils/controller';

export default class extends Controller {
  readonly paths = {
    guestCheckout: '/guest-checkout',
    signIn: '/sign-in'
  };

  readonly cssClass = {
    currentTab: 'elc-tabs__tab--current'
  };

  static targets = ['guestCheckoutTab', 'guestCheckoutForm', 'guestSignInTab', 'guestSignInForm'];

  // guest checkout
  declare guestCheckoutTabTarget: HTMLElement;
  declare guestCheckoutFormTarget: HTMLElement;
  // sign in
  declare guestSignInTabTarget: HTMLElement;
  declare guestSignInFormTarget: HTMLElement;

  toggleGuestTab(event) {
    const { target } = event;
    const { parentElement } = target;
    const {
      guestSignInFormTarget,
      guestCheckoutFormTarget,
      guestSignInTabTarget,
      guestCheckoutTabTarget,
      patchUrl,
      cssClass: { currentTab },
      paths: { guestCheckout, signIn }
    } = this;

    if (
      (target === guestSignInTabTarget || parentElement === guestSignInTabTarget) &&
      guestSignInFormTarget.hidden
    ) {
      guestSignInTabTarget.classList.add(currentTab);
      guestCheckoutTabTarget.classList.remove(currentTab);
      guestSignInFormTarget.hidden = false;
      guestCheckoutFormTarget.hidden = true;
      patchUrl(guestCheckout, signIn);
    } else if (
      (target === guestCheckoutTabTarget || parentElement === guestCheckoutTabTarget) &&
      guestCheckoutFormTarget.hidden
    ) {
      guestSignInTabTarget.classList.remove(currentTab);
      guestCheckoutTabTarget.classList.add(currentTab);
      guestSignInFormTarget.hidden = true;
      guestCheckoutFormTarget.hidden = false;
      patchUrl(signIn, guestCheckout);
    }
  }

  /**
   * Patch URL.
   *
   * Provided a URL fragment (e.g., `/some-path`), replace it with another URL
   * fragment (e.g., `/another-path`).
   *
   * We currently update the browser's URL when toggling between tabs. The
   * objective is to accommodate hub-sites, which employ a location/language
   * suffix that we append to the domain (e.g., `/fr/fr` in
   * `https://www.darphin.eu/fr/fr/sign-in`).
   */
  patchUrl(oldPath: string, newPath: string): void {
    const url = window.location.href.replace(oldPath, newPath);
    history.pushState({}, '', url);
  }
}
